import { PropertyCategoryModel } from '@_types/molecules';
import Picture from '@atoms/pictures/Picture';
import { getModifiers } from '@helpers/functions';

export default function CategoryImage(model: PropertyCategoryModel) {
  const { title, image, url } = model;
  const styleModifier = getModifiers(model, 'kf-m-category-image');

  return (
    <a className={styleModifier} href={url}>
      <Picture {...image} />
      <h2 className="kf-m-category-image__title">{title}</h2>
    </a>
  );
}
